import React from "react";

function MediaEnquiries() {
  return (
    <div className="max-w-3xl mx-auto p-8 mt-10 bg-gradient-to-b from-gray-50 to-gray-100 shadow-2xl rounded-xl border border-gray-300 text-gray-800">
      
      {/* Media Enquiries Section */}
      <div className="bg-white p-6 rounded-xl shadow-xl border border-gray-300">
        <h2 className="text-4xl font-bold text-primary text-center mb-4">Media Enquiries</h2>
        <p className="text-lg text-center text-gray-600 mb-6">
          For media-related inquiries, please contact:
        </p>
        <div className="bg-gray-50 p-6 rounded-xl shadow-md text-center border border-gray-200">
          <h3 className="text-2xl font-semibold text-gray-900">Jeff Renaud</h3>
          <p className="text-lg text-gray-700">Media Relations Consultant</p>
          <p className="text-lg text-gray-700">Western University</p>
          <p className="text-lg text-gray-900 font-semibold mt-2 border-t border-gray-300 pt-2">519-520-7281</p>
        </div>
      </div>

    </div>
  );
}

export default MediaEnquiries;